import React from 'react';
import {
  SMARPANEL_EVALUATION_URL_SCOPE,
  useSmarPanelToolEvaluationUrls,
} from '../hooks/useSmarPanelToolEvaluationUrls';
import { SMARPANEL_TOOLS } from '../utils/smarPanelTools';
import * as S from './smarPanelToolsGrid.styled';

function SmarPanelToolsGrid() {
  const evaluationUrls = useSmarPanelToolEvaluationUrls(
    SMARPANEL_EVALUATION_URL_SCOPE.PORTAL
  );

  return (
    <S.ToolsSection aria-labelledby="smarpanel-tools-heading">
      <S.ToolsHeading id="smarpanel-tools-heading">Ferramentas</S.ToolsHeading>
      <S.ToolsGrid>
        {SMARPANEL_TOOLS.map(tool => {
          const { Logo } = tool;
          const evaluationUrl = evaluationUrls[tool.id];

          return (
            <S.ToolCard key={tool.id}>
              <S.ToolLogoWrap aria-hidden="true">
                <Logo focusable="false" />
              </S.ToolLogoWrap>
              <S.ToolName>{tool.name}</S.ToolName>
              <S.ToolLinkRow>
                <S.ToolLinkLabel>{tool.linkLabel}</S.ToolLinkLabel>
                <S.ToolLinkValue>
                  <S.ToolLink
                    href={tool.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {tool.url}
                  </S.ToolLink>
                </S.ToolLinkValue>
                <S.ToolLinkLabel>Avaliação</S.ToolLinkLabel>
                <S.ToolLinkValue>
                  <S.ToolLink
                    href={evaluationUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {evaluationUrl}
                  </S.ToolLink>
                </S.ToolLinkValue>
              </S.ToolLinkRow>
              <S.ToolSummary>{tool.summary}</S.ToolSummary>
            </S.ToolCard>
          );
        })}
      </S.ToolsGrid>
    </S.ToolsSection>
  );
}

export default SmarPanelToolsGrid;
